import { createSlice } from '@reduxjs/toolkit';

const companyCreatorInitialState = {
  visibility: true,
  companyData: undefined,
};

const initGitVersions = {
  visibility: false,
  selected: undefined,
  data: undefined,
};

const initDataBases = {
  visibility: false,
  selected: undefined,
  data: undefined,
};

const initPleskConnections = {
  visibility: false,
  selected: undefined,
  data: undefined,
};

const modalsInitialState = {
  companyCreator: companyCreatorInitialState,
  gitVersions: initGitVersions,
  databases: initDataBases,
  pleskConnections: initPleskConnections,
};

const modalsSlice = createSlice({
  name: 'modals',
  initialState: modalsInitialState,
  reducers: {
    setCompanyCreator: (state, { payload }) => {
      state.companyCreator.visibility = true;
      state.companyCreator.companyData = payload.companyData;
    },
    clearCompanyCreator: (state, { payload }) => {
      state.companyCreator.visibility = false;
      state.companyCreator.companyData = undefined;
    },
    // ----------------------------------------
    showPleskConnection: (state, { payload }) => {
      state.pleskConnections = payload.pleskConnections;
    },
    clearPleskConnection: (state) => {
      state.pleskConnections = initPleskConnections;
    },
    showMongoConnection: (state, { payload }) => {
      state.databases = payload.databases;
    },
    clearMongoConnection: (state) => {
      state.databases = initDataBases;
    },
    showRepositoryConnection: (state, { payload }) => {
      state.gitVersions = payload.gitVersions || initGitVersions;
      state.gitVersions.visibility = true;
    },
    clearRepositoryConnection: (state) => {
      state.gitVersions = initGitVersions;
    },
  },
});

export default modalsSlice.reducer;
export const {
  setCompanyCreator,
  clearCompanyCreator,
  showPleskConnection,
  clearPleskConnection,
  showMongoConnection,
  clearMongoConnection,
  showRepositoryConnection,
  clearRepositoryConnection,
} = modalsSlice.actions;
